import { render, staticRenderFns } from "./CrudForm.vue?vue&type=template&id=e7ddf7e4&scoped=true"
import script from "./CrudForm.vue?vue&type=script&lang=js"
export * from "./CrudForm.vue?vue&type=script&lang=js"
import style0 from "./CrudForm.vue?vue&type=style&index=0&id=e7ddf7e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7ddf7e4",
  null
  
)

export default component.exports